// extracted by mini-css-extract-plugin
export default {"resetForm":"PasswordReset_resetForm__nwLSn","error":"PasswordReset_error__A2FQ9","center":"PasswordReset_center__XkMby"};